export default "__VITE_ASSET__CeD9esOO__"